import React from 'react';
import {loaderSVG, SampleGroupProfile} from '../../../assets/images';
import NewGroupProfile from './NewGroupProfile';
import NewParticipants from './NewParticipants';

const CreateNewGroup = (props = {}) => {
    const style = { width: 50, height: 50 };
    const { handleBackToRecentChat } = props;
    const [getCreateNewGroup, setCreateNewGroup] = React.useState({
        profileView: true,
        groupImage:SampleGroupProfile,
        typedMessage:'',
        loading:false
    });
    const { profileView, groupImage, typedMessage, loading} = getCreateNewGroup;
    const changeScreen = (groupInfo = {}) => {
        const {typingMessage, groupProfileImage, profileImage} = groupInfo
            setCreateNewGroup({...getCreateNewGroup,
                profileView:!profileView,
                loading:true,
                typedMessage: typingMessage ? typingMessage : typedMessage,
                groupImage:(profileImage) ? groupProfileImage : groupImage,
        },
        // ()=>{
        //     setCreateNewGroup({...getCreateNewGroup,
        //         loading:false
        //     })
        // }
        )
    }

    return (
        <React.Fragment>
            <div className="loader">
                {loading && <img src={loaderSVG} alt="message-history" style={style} />}
            </div>
            {
                profileView && 
                    <NewGroupProfile
                        handleBackToRecentChat={handleBackToRecentChat}
                        typingMessage={typedMessage}
                        groupProfileImage={groupImage}
                        handleMoveToPartcipantList={changeScreen}
                    />
            }
            {
                !profileView && 
                    <NewParticipants
                        typingMessage={typedMessage}
                        groupProfileImage={groupImage}
                        handleBackToGroup={changeScreen}
                        handleBackToRecentChat={handleBackToRecentChat}
                    />
            }
        </React.Fragment>
    )
};
export default CreateNewGroup;
